import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';
// components
import GradientTag from '../../../../components/reusable/GradientTag';
import Vendors from '../../../../components/reusable/vendors/Index';
// assets
import Hero_gradient_bg from '../../../../images/product-assets/hero-gradient-bg.png';
import Hero_fingerprint_bg from '../../../../images/product-assets/fingerprint.svg';
import { formatText } from '../../../../utils';
import { useModal } from '../../../../context/ModalContext';

const Container = styled.section`
    padding-top: 50px;
    background: #fff;
    position: relative;
    overflow: hidden;
`;

const HeroContainer = styled.div`
    z-index: 3;
    max-width: 1280px;
    margin: 0 auto;
    padding: 95px 20px 50px;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (max-width: 500px) {
        padding: 32px 16px;
    }
`;

const Heading = styled.h1`
    color: #03045e;
    font-size: 64px;
    font-weight: 500;
    line-height: 76px;
    text-align: center;
    margin-top: 28px;
    z-index: 3;

    @media screen and (max-width: 500px) {
        font-size: 24px;
        font-weight: 500;
        line-height: 28px;
        margin-top: 16px;
    }
`;

const SubHeading = styled.p`
    font-size: 18px;
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    color: #52525b;
    margin-top: 28px;
    width: 50%;
    z-index: 4;

    @media screen and (max-width: 500px) {
        font-size: 14px;
        font-weight: 400;
        line-height: 17px;
        text-align: center;
        margin-top: 16px;
        width: 100%;
    }
`;
const BtnGroup = styled.div`
    margin-top: 44px;
    display: flex;
    flex-direction: row;
    gap: 24px;
    justify-content: center;
    align-items: center;
    z-index: 3;

    @media screen and (max-width: 500px) {
        margin-top: 32px;
        flex-direction: column;
    }
`;
const SharedCtaStyles = css`
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    color: #fff;
    background: #03045e;
    padding: 12px 24px;
    border-radius: 6px;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        transform: scale(1.1);
        transition: all 0.2s;
    }

    @media screen and (max-width: 500px) {
        width: 200px;
        text-align: center;
    }

    ${({ secondary }) =>
        secondary &&
        css`
            border: none;
            background: #fff;
            color: #333;
            border: 1px solid rgba(51, 51, 51, 0.5);
        `};
`;
const CtaLink = styled.a`
    ${SharedCtaStyles}
`;

const CtaButton = styled.button`
    ${SharedCtaStyles}
`;
const ProductAnimation = styled.img`
    margin-top: 100px;
    width: 100%;
    z-index: 6;
    position: relative;

    @media screen and (max-width: 500px) {
        margin-top: 36px;
    }
`;

const HeroGradient = styled.img`
    width: 100%;
    position: absolute;
    bottom: 0;

    @media screen and (max-width: 500px) {
        height: 400px;
        width: auto;
        left: 50%;
        transform: translateX(-50%);
    }
`;

const HeroPattern = styled.img`
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;

    @media screen and (max-width: 500px) {
        display: none;
    }
`;

function HeroSection({ tag, heading, subHeading, heroImage, signUpCtaLink }) {
    const { openModal } = useModal();
    return (
        <Container id="heroSection">
            <HeroContainer>
                <GradientTag text={tag} />
                <Heading>{heading}</Heading>
                <SubHeading>{formatText(subHeading)}</SubHeading>
                <BtnGroup>
                    <CtaLink
                        href={signUpCtaLink || 'https://portal.authenticate.com/register'}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Sign Up
                    </CtaLink>
                    <CtaButton type="button" secondary onClick={() => openModal('contact')}>
                        Schedule a Demo
                    </CtaButton>
                </BtnGroup>
                <ProductAnimation src={heroImage} alt={tag} />
                <Vendors theme="dark" />
            </HeroContainer>
            <HeroGradient src={Hero_gradient_bg} alt="background gradient" />
            <HeroPattern src={Hero_fingerprint_bg} alt="background pattern" />
        </Container>
    );
}

HeroSection.propTypes = {
    tag: PropTypes.string,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    heroImage: PropTypes.string,
    signUpCtaLink: PropTypes.string,
};

export default HeroSection;
